import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\chatbot\\ChatbotButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\home\\CoreValuesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\home\\DepartmentsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\home\\HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\home\\NewsletterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\home\\NewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\home\\PartnersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\home\\ResearchCPDSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\home\\ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\home\\StatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\home\\TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\home\\TopSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\layout\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\jonas\\Desktop\\AMSH\\frontend\\components\\layout\\Navbar.tsx");
